import type { ReactElement } from 'react';
import cx from 'classnames';

import { makeStyles } from '@mui/styles';
import { FormControlLabel } from '@mui/material';
import Callout from '@classify/react-core-components/Callout';

import { RichContent } from '@openclassrooms/ui-web/rich-content';

interface Props {
  content: string;
  isCorrect?: boolean;
  control: ReactElement;
  isCompleted?: boolean;
  warningLabel?: string;
}

const useStyles = makeStyles(({ spacing, breakpoints, typography }) => ({
  disabled: {
    opacity: 0.8,
  },
  answerWrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&:not(:last-child)': {
      marginBottom: spacing(1),
    },
  },
  contentWrapper: {
    '& p': {
      margin: [0, '!important'],
    },
    '& pre': {
      margin: [0, '!important'],
      maxWidth: '98%',
      [breakpoints.up('sm')]: {
        maxWidth: '100%',
      },
      '& > code': {
        marginLeft: 0,
        marginRight: 0,
        marginTop: [0, '!important'],

        '&::before': {
          display: 'none',
        },
      },
      '& + p': {
        height: 0,
      },
    },
  },
  correctAnswerWrapper: {
    '& p': {
      fontWeight: `${typography.fontWeightBold} !important`,
    },
  },
  alert: {
    width: 'fit-content',
    margin: spacing(1, 0, 0, 4),
  },
}));

const AnswerWrapper = ({
  content,
  isCorrect = false,
  control,
  isCompleted = false,
  warningLabel = '',
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.answerWrapper}>
      <FormControlLabel
        label={
          <RichContent
            content={content}
            className={cx(classes.contentWrapper, isCorrect ? classes.correctAnswerWrapper : null)}
          />
        }
        control={control}
        disabled={isCompleted && !isCorrect}
        classes={{ disabled: classes.disabled }}
      />

      {warningLabel && (
        <Callout type="warning" className={classes.alert}>
          {warningLabel}
        </Callout>
      )}
    </div>
  );
};

export default AnswerWrapper;
